import React, {Component} from 'react';
import firebase from 'firebase/app';
import 'firebase/database';
import FontAwesome from 'react-fontawesome';
import {EditorDialog} from '../editor-components';
import CategorySelect from './category-select';

/** @class CreateAffiliateDialog
  * A component for creating a new affiliate.
  */
export default class CreateAffiliateDialog extends Component {
  /** @constructor
    * Constructs a new CreateAffiliateDialog instance
    */
  constructor(props) {
    super(props);
    this.state = {
      organization: '',
      group: '',
      email: '',
      phone: '',
      token: '',
      notes: '',
    }
    this.handleSave = this.handleSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.checkUniqueness = this.checkUniqueness.bind(this);
}
  /** @function handleChange
    * Applies user changes to the state
    * @param {InputEvent} event - the triggering event
    */
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }
  /** @function checkUniqueness
    * Checks the uniqueness of the proposed token
    * and displays the results using the HTML validation
    * API
    */
  checkUniqueness(event) {
    const tokenToCheck = event.target.value;
    if(this.props.claimedTokens.includes(tokenToCheck)) {
      event.target.setCustomValidity("That token is already in use.  Please try another.");
    } else {
      event.target.setCustomValidity("");
    }
  }
  /** @function handleSave
    * Applies the current state to the database,
    * clears the form, and closes the dialog.
    */
  handleSave(event) {
    event.preventDefault();
    firebase.database().ref(`/affiliates/${this.state.token}`).set(this.state)
    .then(()=>{
      this.setState({
        organization: '',
        group: '',
        email: '',
        phone: '',
        token: '',
        notes: '',
      });
      this.props.onExit();
    });
  }
  /** @method render
    * Renders the component
    */
  render() {
    const style={maxWidth: "80vw"}
    return (
      <EditorDialog show={this.props.show} onExit={this.props.onExit}>
        <form onSubmit={this.handleSave} style={style}>
          <h3>Add New Affiliate</h3>
          <div className="input-group">
            <label htmlFor="organization">Organization</label>
            <input name="organization" type="text"
              value={this.state.organization}
              onChange={this.handleChange}
              onBlur={this.handleBlur}
              required
              minLength={1}/>
            <p className="hint">
              The overall organization name; i.e. Boy Scouts, 4H Shooting Sports...
            </p>
          </div>
          <CategorySelect name="category"
            value={this.state.category}
            onChange={this.handleSelect}
            />
          <p className="hint">
              The category of this organization, i.e. Youth, Vetrans, etc.
          </p>
          <div className="input-group">
            <label htmlFor="group">Group</label>
            <input name="group" type="text"
              value={this.state.group}
              onChange={this.handleChange}/>
            <p className="hint">
              Put the name of the subgroup (club, troop, etc.)
              here.  Leave blank for the overall organization&apos;s affilate entry.
            </p>
          </div>
          <div className="input-group">
            <label htmlFor="token">Token</label>
            <input name="token" type="token"
              value={this.state.token}
              onChange={this.handleChange}
              required
              minLength={3}
              pattern="[\-_\w]+"
              onBlur={this.checkUniqueness}
              />
            <p className="hint">
              A unique token for identifying the group, i.e. NemaCo
              for Nema County 4H or Troop64 for Boy Scout Troop 64.
              Should not contain punctuation, spaces, or symbols
              (other than dash and underscore) and cannot
              be changed once the affiliate has been created.
            </p>
          </div>
          <div className="input-group">
            <label htmlFor="contact">Contact Name</label>
            <input name="contact" type="text"
              value={this.state.contact}
              onChange={this.handleChange}/>
            <p className="hint">
              The main contact person&apos;s name for this organization or group
            </p>
          </div>
          <div className="input-group">
            <label htmlFor="email">Contact Email</label>
            <input name="email" type="email"
              value={this.state.email}
              onChange={this.handleChange}/>
            <p className="hint">
              The main contact email for this organization/group
            </p>
          </div>
          <div className="input-group">
            <label htmlFor="phone">Contact Phone</label>
            <input name="phone" type="phone"
              value={this.state.phone}
              onChange={this.handleChange}
              pattern="[0-9]{3}[ -][0-9]{3}[ -][0-9]{4}"
              />
            <p className="hint">
              The main contact phone number for this organization/group,
              separated by dashes (###-###-####)
            </p>
          </div>
          <div className="input-group">
            <label htmlFor="notes">Notes</label>
            <textarea name="notes"
              value={this.state.notes}
              onChange={this.handleChange}/>
            <p className="hint">
              A place to keep notes on the organization or group.
            </p>
          </div>
          <div className="button-group">
            <button type="submit" className="btn btn-success">
              <FontAwesome name="save"/>
              Save Affiliate
            </button>
          </div>
        </form>
      </EditorDialog>
    );
  }
}



// WEBPACK FOOTER //
// ./src/affiliate-list/create-affiliate-dialog.js